/**
 * Catalogo de informes del hub: metadatos de UI y filtros.
 * La lista clicable esta en reportHub-page.html; aqui solo se resuelve la definicion por reportId.
 */

const REPORT_DEFINITIONS = [
  // —— Customer ——
  {
    entity: "customer",
    id: "account-receivable-one",
    reportname: "account-receivable-one",
    label: "Accounts receivable — one customer",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: false,
    filterPeriod: false,
    sendEmailEnabled: true,
  },
  {
    entity: "customer",
    id: "account-receivable-detail",
    reportname: "account-receivable-detail",
    label: "Accounts receivable detail — one customer",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "customer",
    id: "account-receivable-all",
    reportname: "account-receivable-all",
    label: "Accounts receivable — all customers",
    needsAutocomplete: false,
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "customer",
    id: "customer-profit-all",
    reportname: "customer-profit-all",
    label: "Customer profit — all customers",
    needsAutocomplete: false,
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "customer",
    id: "customer-profit-one",
    reportname: "customer-profit-one",
    label: "Customer profit — one customer",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "customer",
    id: "customer-profit-period",
    reportname: "customer-profit-period",
    label: "Customer profit — one customer (period)",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: true,
  },

  // —— Provider ——
  {
    entity: "provider",
    id: "account-payable-one",
    reportname: "account-payable-one",
    label: "Accounts payable — one provider",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "provider",
    id: "account-payable-all",
    reportname: "account-payable-all",
    label: "Accounts payable — all providers",
    needsAutocomplete: false,
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "provider",
    id: "account-all-profit",
    reportname: "account-all-profit",
    label: "Provider profit — all providers",
    needsAutocomplete: false,
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "provider",
    id: "account-all-profit2",
    reportname: "account-all-profit",
    label: "Provider profit — one provider",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "provider",
    id: "account-all-profit-period",
    reportname: "account-profit-period",
    label: "Provider profit — one provider (period)",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: true,
  },

  // —— Purchase ——
  {
    entity: "purchase",
    id: "purchase-report-one",
    reportname: "purchase-report-one",
    label: "Purchase — status report",
    needsAutocomplete: true,
    autocompleteEntity: "purchase",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "purchase",
    id: "purchase-invoice",
    reportname: "purchase-invoice",
    label: "Purchase — invoice (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "purchase",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },

  // —— Sale ——
  {
    entity: "sale",
    id: "sale-invoice",
    reportname: "sale-invoice",
    label: "Sale — invoice (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "sale",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "sale",
    id: "sale-pack-slip",
    reportname: "sale-pack-slip",
    label: "Sale — packing slip (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "sale",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },

  // —— Inventory ——
  {
    entity: "inventory",
    id: "inventory-item-one",
    reportname: "inventory-item-one",
    label: "Inventory — items report",
    needsAutocomplete: true,
    autocompleteEntity: "item",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },

  {
    entity: "inventory",
    id: "inventory-item-history",
    reportname: "inventory-item-history",
    label: "Inventory — items history",
    needsAutocomplete: true,
    autocompleteEntity: "item",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },

  {
    entity: "inventory",
    id: "inventory-items-available",
    reportname: "inventory-items-available",
    label: "Inventory — items available",
    needsAutocomplete: false,
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },

  // —— Transaction ——
  {
    entity: "receivepayment",
    id: "receivepayment-one",
    reportname: "receivepayment-one",
    label: "Transaction — receive payment (one)",
    needsAutocomplete: true,
    autocompleteEntity: "receivepayment",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "sentpayment",
    id: "sentpayment-one",
    reportname: "sentpayment-one",
    label: "Transaction — send payment (one)",
    needsAutocomplete: true,
    autocompleteEntity: "sentpayment",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
  {
    entity: "otherexpense",
    id: "otherexpense-report",
    reportname: "otherexpense-report",
    label: "Other expense",
    needsAutocomplete: true,
    autocompleteEntity: "otherexpense",
    autoPrintWithoutUI: false,
    filterDateRange: false,
    filterYear: false,
    filterPeriod: false,
  },
];

export function getReportDefinition(reportId) {
  return REPORT_DEFINITIONS.find((r) => r.id === reportId);
}
